import { useCallback, useState } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import IconButton from 'fe-design-base/molecules/IconButton';

import { orderReasons } from 'features/scheduleBuilder/slices/reassignmentRecommendations/helper';
import {
  Reason,
  ReasonKey,
} from 'features/scheduleBuilder/slices/reassignmentRecommendations/types';

import { toI18n } from 'util/i18n';

import { REASON_MAP } from '../ReassignmentSelector/ReassignmentRecommendations/ReassignmentSelectorCard';

const I18N_PATH = 'my_week.user.shift_trade_requests.smart_cover_requests';

interface Props {
  insights: Array<Reason & { reason_key: ReasonKey }>;
}

const SmartCoverRequestInsights = ({ insights }: Props) => {
  const [showInsights, setShowInsights] = useState(false);
  const handleShowInsights = useCallback(
    () => setShowInsights(!showInsights),
    [showInsights]
  );
  return (
    <Box>
      {(insights?.length ?? 0) > 0 && (
        <>
          <Box flex>
            <Text variant="bodyBold">{toI18n(`${I18N_PATH}.insights`)}</Text>
            <Box relative bottom={4}>
              <IconButton
                onClick={handleShowInsights}
                icon={showInsights ? 'ChevronUp' : 'ChevronDown'}
                label={
                  showInsights
                    ? toI18n('schedule_builder.actions.hide_insights')
                    : toI18n('schedule_builder.actions.show_insights')
                }
                size="small"
              />
            </Box>
          </Box>
          {showInsights && (
            <Box>
              {orderReasons(insights).map(
                ({ reason_key, reason }) =>
                  REASON_MAP[reason_key] && (
                    <Box row vcenter gap={8} key={reason_key}>
                      <Icon
                        iconName={REASON_MAP[reason_key].icon}
                        color={REASON_MAP[reason_key].color}
                        size="small"
                      />
                      <Text color="mono900" noWrap variant="captions">
                        {reason}
                      </Text>
                    </Box>
                  )
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default SmartCoverRequestInsights;
